<template>
  <div class="screen-container">
    <!-- Small devices -->
    <mq-layout :mq="['mobile', 'tablet']" v-if="$mq != 'desktop'">
      <div class="Masterclass-List-Container">
        <div :class="`Masterclass-List-Item-${$mq}`" v-for="theme in globalThemes" :key="theme.id">
          <masterclass-tile :id="theme.id" />
        </div>
      </div>
      <div class="feedback-button">
        <button v-if="isRecommendations" class="reco-button" @click="this.showModal">
          <img src="@/assets/recommendation_picto.png" />
          <span>{{ $t('forms.feedback') }}</span>
        </button>
      </div>
    </mq-layout>

    <!-- Desktop -->
    <mq-layout mq="tablet+" v-else>
      <div class="header-shadow" :style="{ backgroundImage: 'url(' + bgImg + ')' }"></div>
      <div class="container">
        <div class="Masterclass-List-Group" v-if="globalThemes.length > 0">
          <div class="Masterclass-List-Container-Desktop">
            <div
              class="Masterclass-List-Item-desktop"
              v-for="theme in globalThemes"
              :key="theme.id"
            >
              <masterclass-tile :id="theme.id" />
            </div>
          </div>
        </div>
      </div>
    </mq-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import MasterclassTile from '@/components/masterclass/MasterclassTile'
import userMixin from '@/mixins/user'
import { isMasterclassComplete, isMasterclassStarted } from '@/helpers/userCompletion'

import VvModal from '@/components/common/VvModal.vue'
import remoteConfig from '@/lib/remote-config'

export default {
  name: 'ThemeList',
  components: { MasterclassTile },
  mixins: [userMixin],
  data() {
    return {
      etapes: [],
      bgImg: require('@/assets/background-visite.jpg')
    }
  },
  computed: {
    ...mapGetters({
      themes: 'getThemes',
      funnels: 'themeFunnels',
      lessonsSteps: 'lessonSteps'
    }),
    globalThemes() {
      return this.themes.sort((masterclass1, masterclass2) => {
        return masterclass1.order - masterclass2.order
      }) // .map(passer ici une propriete en plus au div indice 0 et n)
    },
    isRecommendations() {
      return remoteConfig.getValue('recommendations') == '' ? false : true
    }
  },
  coordinates() {
    return this.sortMasterclass(
      this.allMasterclassIds
        .filter(id => this.$store.getters.getThemeById(id).wineMaking)
        .map(id => this.$store.getters.getThemeById(id))
        .sort((masterclass1, masterclass2) => masterclass1.order - masterclass2.order)
    )
  },

  mounted() {
    if (this.themes.length === 1) {
      this.$router.replace({ name: 'theme', params: { themeId: this.themes[0].id } })
    }

    if (localStorage.getItem('triggerModal')) {
      this.showModal()
      localStorage.removeItem('triggerModal')
    }
  },
  methods: {
    /**
     * @param {string} themeId
     * @returns {'unstarted' | 'started' | 'finished'}
     */
    status(themeId) {
      if (isMasterclassComplete(themeId)) return 'finished'

      if (isMasterclassStarted(themeId)) return 'started'

      return 'unstarted'
    },
    /**
     * @param {string} themeId
     * @returns {string}
     */
    themeNotice(themeId) {
      const duration = this.$store.getters.themeDuration(themeId)

      return this.$tc('masterclass.notice', duration, { duration })
    },

    /**
     * Call VvModal
     * Set proprities for popup recommendations
     */
    showModal() {
      this.$modal.show(
        VvModal,
        {},
        {
          adaptive: true,
          reset: true,
          styles: {
            'border-radius': '20px',
            height: '400px,'
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.container {
  display: flex;
  flex-direction: column;
  border-radius: 60px 60px 0px 0px;
  background-color: #fff;
  width: 100%;
  height: 100%;
  float: left;
  position: absolute;
  margin-top: -60px;
}
.header-shadow {
  margin-top: 75px; //for navbar
  width: 100%;
  height: 625px;
  background-attachment: fixed;
}
.title {
  text-align: center;
  font: normal normal 600 25px/30px Montserrat;
  letter-spacing: 0px;
  color: #000000;
}
.leftButton {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.backButton {
  margin-right: 35px;
  cursor: pointer;
  // background-color: #ffffff;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  // box-shadow:  3px 3px 3px #bebebe,
  //            -4px -4px 4px #ffffff;
  img {
    height: 60%;
    width: 60%;
    margin-right: 4px;
    transform: rotate(180deg);
  }
  // &:hover {
  // box-shadow:  -3px -3px 4px #bebebe,
  //            3px 3px 2px #ffffff;
  // }
}
.global-themes {
  margin-top: 40px;
}

.theme-list {
  a {
    text-decoration: none;

    .theme-container {
      background-color: #fff;
      transition: 200ms;
      padding: 0 15px;
      box-sizing: border-box;

      &:hover {
        background-color: #efefef;
      }

      .theme-wrapper {
        padding: 20px 0;
      }
    }
  }
}

.Masterclass-List-Container {
  padding-bottom: 50px;
}

.Masterclass-List-Container-Desktop {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 110px;
}
.Masterclass-List-Group {
  margin-bottom: 60px;
}

.Masterclass-List-Title {
  cursor: pointer;
  color: $primary;
  font-weight: bold;
  font-size: 23px;
  margin-top: 10px;
}

.Masterclass-List-Item-mobile,
.Masterclass-List-Item-tablet {
  padding-bottom: 40px;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
}
.Masterclass-List-Item-desktop {
  cursor: pointer;
  display: inline-block;
  margin-top: 20px;
  box-sizing: border-box;
  width: 700px;
}
// .scan-button {
//   position: absolute;
//   border: none;
//   outline: none;
//   background: none;
//   border-radius: 4px;
//   right: 85px;
// }
// .scan-button:hover {
//   cursor: pointer;
// }
// @media screen and (max-width: 420px) {
//   .scan-button {
//     right: 55px;
//     img {
//       width: 40px;
//     }
//   }
// }
// @media screen and (min-width: 1281px) {
//   .scan-button {
//     display: none;
//   }
// }
// .geoloc-button {
//   position: absolute;
//   border: none;
//   outline: none;
//   background: none;
//   border-radius: 4px;
//   right: 10px;
// }
// .geoloc-button:hover {
//   cursor: pointer;
// }
// @media screen and (max-width: 420px) {
//   .geoloc-button {
//     right: 5px;
//     img {
//       width: 40px;
//     }
//   }
// }

.reco-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  padding: 10px 20px;
  border: solid;
  border-width: 2px;
  border-radius: 40px;
  color: black;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  margin-right: auto;
  margin-left: auto;

  img {
    height: 20px;
    width: 20px;
    margin-right: 15px;
  }
}

.long-arrow-left {
  display: block;
  width: 25px;
  height: 25px;
  border-top: 2px solid #000;
  border-left: 2px solid #000;
  flex-direction: row;
}

.long-arrow-left {
  transform: rotate(-45deg);
}

.long-arrow-left::after {
  content: '';
  display: block;
  width: 2px;
  height: 45px;
  background-color: black;
  transform: rotate(-45deg) translate(15px, 4px);
  left: 0;
  top: 0;
}

.holder {
  display: inline;
}
.holder img {
  max-height: 50px;
  max-width: 50px;
  object-fit: cover;
}

.container-back-button {
  display: flex;
  flex-direction: row;
}
.feedback-button {
  margin-top: 15px;
  margin-bottom: 15px;
}
</style>
